<template>
  <div
    class="
      overflow-hidden rounded-bl-xl will-change-transform
      print:break-inside-avoid-page
    "
  >
    <!-- HEADER -->
    <div class="mb-2 flex flex-wrap items-center gap-x-5 gap-y-1">
      <!-- Date -->
      <div
        class="
          relative w-fit space-y-1 rounded-bl-lg bg-gray-500 py-2 pl-3 pr-8
          text-base leading-none text-white
        "
      >
        <time v-if="data.date_start !== data.date" class="block font-semibold" :datetime="data.date_start">{{ dateStart }}</time>

        <time class="block font-semibold" :datetime="data.date">{{ dateEnd }}</time>
        <p v-if="data.time_slot">
          {{ data.time_slot }}
        </p>
      </div>

      <!-- Location -->
      <div>
        <h4 class="typo-h-5 text-gray-500">
          {{ $t('location_of_event') }}
        </h4>
        <Component
          v-bind="data.event_location_link ? { href: data.event_location_link, target: '_blank'}: null"
          :is="data.event_location_link ? 'a':'p'"
          v-if="data.event_location || data.event_location_link"
          class="text-gray-500"

          :class="{'transition-colors duration-300 hover:text-red-500': data.event_location_link}"
        >
          {{ data.event_location }}
        </Component>
      </div>
      <!-- Publisher -->
      <!-- <p v-if="publisher" class="line-clamp-1 text-gray-500">
        {{ publisher }}
      </p> -->
    </div>

    <!-- CONTENT -->
    <div class="bg-gray-200" :class="{'grid grid-cols-2 max-sm:grid-cols-1': !isSidebar}">
      <!-- Image -->
      <div v-if="!isSidebar" class="relative">
        <AppImage
          v-if="data.image"
          :src="data.image"
          :aspect-ratio="3 / 2"
          class="absolute inset-0 size-full object-contain"
        />
      </div>
      <!-- Text -->
      <div class="p-5">
        <h3
          class="
            typo-h-3 mb-3 line-clamp-3
            sm:mb-5
          "
        >
          {{ data.heading }}
        </h3>

        <div
          v-if="data.text"
          class="wysiwyg-only-lists line-clamp-5"
          v-html="data.text"
        />

        <!-- Links -->
        <div v-if="links" class="mt-6 flex flex-wrap gap-x-3 gap-y-1">
          <template v-for="item in links">
            <AppButton
              v-if="item.link"
              :key="item.id"
              :to="item.link"
              variant="primary"
              show-external-icon
              class="hover-focus:bg-transparent"
            >
              {{ item.link_text }}
            </AppButton>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object, required: true,
  },
})

const isSidebar = inject<boolean>('isSidebar', false)

const {
  t, locale, locales,
} = useI18n()

const dateStart = computed(() => {
  return formatDate(props.data.date_start)
})

const dateEnd = computed(() => {
  return formatDate(props.data.date)
})

function formatDate(date: string) {
  if (!date) return

  const dateObject = new Date(date)

  if (!dateObject) return

  // Find the locale in the list of available locales by code
  const localeObj = locales.value.find(site => site.code === locale.value)

  return dateObject.toLocaleDateString(localeObj?.language || 'de-CH', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

// Merge external link with other links
const links = computed(() => {
  /*
  * If the article has a external link, add it to the list of links.
  * Else add the articles url to the list of links
  */

  const link = props.data.link_external || props.data.url

  const linkObject = {
    link,
    link_text: t('more'),
  }

  return [
    linkObject,
    ...(props.data.links && props.data.links.length ? props.data.links : []),
  ]
})

const publisher = computed(() => {
  if (props.data.publisher) {
    return props.data.publisher.title
  }

  return props.data.site_attributes.find(attr => attr.key === 'title')?.value
})
</script>
